import React, {useEffect, useRef} from 'react';

export default function NewFeaturesModal({isOpen, onClose, title, darkMode}) {
  const modalRef = useRef();

  const changesList = [
    "Modals can now be maximized to include more info on the initial display (including comments visible when maximized for the website view)",
    "Modal sections are now scrollable with the scroll wheel in addition to the navigation buttons along the left column",
    "Vendors can be marked as being allowed Reciprocal Users (Not yet exposed/visible in Veranda)",
    "Custom table exports, mark specific columns for export on the websites and vendors tables",
    "Dark Mode switch moved from navbar into user settings",
    "Modal loading improvements",
    "Bug fixes"
  ];

  useEffect(() => {
    const handleMouseUp = (event) => {
      if (isOpen && modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-stone-950 bg-opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <div
          ref={modalRef}
          className="inline-block align-bottom bg-white dark:bg-stone-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div className={`bg-white dark:bg-stone-800 p-5 sm:p-6 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
            <div className="flex justify-between items-center">
              <h2 className="text-lg font-bold dark:text-gray-300">{title}</h2>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </button>
            </div>
            <div className="mt-4">
              <h3 className="font-semibold text-lg dark:text-gray-300"
                  style={{borderBottom: '1px solid', borderColor: darkMode ? 'gray-600' : 'gray-200'}}>
                Notable Changes on the DLM Side</h3>
              <ul className="list-disc pl-5 mt-4 dark:text-gray-300">
                {changesList.map((change, index) => (
                  <li key={index} className="mt-2">{change}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
